import get from 'lodash/get';
import {createEventHandler} from 'recompose';
import {Observable} from 'rxjs';
import 'rxjs/add/operator/combineLatest';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/map';
import fuse from '../../../_libs/redux-fusion/index';
import {stateGoEnter} from '../../../app/actions';
import {selectedProject} from '../../../app/model/actions';
import {getAsset, getAssetModel, getAssetProjectModel} from '../../../app/model/reducers/state';
import {buildAssetLink$, buildOrganizationLink$} from '../../../app/navigation/utils';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {ReduxListStreamedContainer} from '../../../core-utilities/redux/ReduxListContainer';
import {assetTasksStates} from '../../../tasks/router-config';
import {componentOptions, reduxList} from '../../redux/assetsProjectsList';
import {updateAssetRequestModal} from '../../redux/updateAsset';
import {AssetViewOverviewView} from './AssetViewOverviewView';


const StreamedComponent = (state$, dispatch) => (props$) => {
  const selectThenNav = (project, navAction) => {
    dispatch(selectedProject(get(project, 'project.id')));
    dispatch(navAction);
  };
  const onClickItem = (e, project) => selectThenNav(project, stateGoEnter({state: assetTasksStates.tasks}));
  const onClickEdit = createEditEvent(state$, dispatch, props$);

  const breadcrumbPath$ = buildBreadcrumbPath$(state$);

  const asset$ = state$
    .map(getAsset)
    .distinctUntilChanged();

  const assetProject$ = state$
    .map(getAssetProjectModel)
    .distinctUntilChanged();

  return props$
    .combineLatest(
      breadcrumbPath$,
      asset$,
      assetProject$,
      (props, breadcrumbPath, asset, assetProject) => ({
        ...props,
        breadcrumbPath,
        parentId: getId(asset),
        asset,
        assetProject,
        onClickEdit,
        onClickItem,
      }));
};

// The fuse container must inject the parentId into the ReduxListStreamedContainer
export const ListComponent = ReduxListStreamedContainer(AssetViewOverviewView, reduxList, componentOptions);
export const AssetViewOverviewContainer = fuse(StreamedComponent)(ListComponent);

function buildBreadcrumbPath$(state$) {
  return Observable
    .combineLatest(
      buildOrganizationLink$(state$),
      buildAssetLink$(state$),
      (projectLink, assetProjectLink) => [projectLink, assetProjectLink]
    );
}

/**
 * @param {Observable} state$
 * @param {Function} dispatch
 * @param {Observable} props$
 */
function createEditEvent(state$, dispatch, props$) {
  const {
    handler: onClickEdit,
    stream: edit$,
  } = createEventHandler();

  edit$
    .withLatestFrom(state$)
    .takeUntil(props$.last())
    .subscribe(([e, rootState]) => {
      e.stopPropagation();
      const asset = getAssetModel(rootState);
      dispatch(updateAssetRequestModal.actions.showModal({model: asset}));
    });

  return onClickEdit;
}



// WEBPACK FOOTER //
// ./src/js/assets/components/AssetViewOverview/AssetViewOverviewContainer.js